import { Component, OnInit, OnDestroy } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ConfirmModalPopupModel } from 'lib/ng2-sapmp/src/ui-components/confirm-modal';
import { ValidationService, AuthenticationService, UtilityService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { CartModel, PaymentDetailsModel, BtmPaymentMethodModel, RequestEligibilityDetailsModel } from './../../../models';
import { UserProfileModel, AccountModel } from 'lib/ng2-sapmp/src/models';
import { StepIndicatorService } from 'lib/ng2-sapmp/src/ui-components/step-indicator';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';
import { DropdownModel } from 'lib/ng2-sapmp/src/ui-components/dropdown';
import { KEY_CONFIG } from 'lib/ng2-sapmp/src/config/key-config';
import { BillingPaymentService } from './shared';
import { CartService } from '../../cart/cart.service';
import { DROPDOWN } from 'config';

declare var ENV_VAR: any; // global variable set in env.js file, imported in index.html
declare var logoutCurrentUser: any;
declare var ENV_PORTAL: any;

@Component({
  selector: 'app-billing-payment',
  providers: [ValidationService, BillingPaymentService, AdobeAnalyticsService, CartService],
  templateUrl: './billing-payment.component.html',
  styleUrls: ['./../checkout.component.scss']
})
export class BillingPaymentComponent implements OnInit, OnDestroy {
  billingpaymentform: FormGroup;
  fanNumbers: Array<DropdownModel>;
  banNumbers: Array<DropdownModel>;
  ctnNumbers: Array<string>;
  selectedFan: DropdownModel;
  selectedBan: DropdownModel;
  selectedCtn: string;
  removeProductModalPopup: ConfirmModalPopupModel;
  editFbtn: boolean;
  editBbtn: boolean;
  editCbtn: boolean;
  shownFan: string;
  shownBan: string;
  banMatch: boolean;
  ctnMatch: boolean;
  showFanDropDown: boolean;
  showBanDropDown: boolean;
  showCtnDropDown: boolean;
  banSectionEnable: boolean;
  ctnSectionEnable: boolean;
  setError: boolean;
  ErrorMessage: string;
  continueToProdConfig: boolean;
  user: UserProfileModel;
  cart: CartModel = null;
  paymentdetails: PaymentDetailsModel;
  selectedValueFlag: boolean;
  cancelCheckout: boolean;
  cancelMessage = 'Do you want to cancel the checkout?';
  dropDownPlaceholder: string;
  banField: boolean;
  dropbanDownPlaceholder: string;
  invalidFan = false;
  fanMessage: string;
  errorFlag= false;
  errorBanFlag = false;
  modalClass: string;
  removeProd = false;
  product: RequestEligibilityDetailsModel;
  cartList: Array<any> = [];
  eligibleList: Array<any> = [];
  formErrors = {
    'ban': '',
    'ctn': ''
  };
  validationMessages = {
    'ban': {
      'pattern': 'Enter a valid billing account.'
    },
    'ctn': {
      'pattern': 'Enter a valid wireless number.'
    }
  };

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private stepindicatorService: StepIndicatorService,
    private formBuilder: FormBuilder,
    private validationService: ValidationService,
    private billingPaymentService: BillingPaymentService,
    private adobeAnalyticsService: AdobeAnalyticsService,
    private utilityService: UtilityService,
    private authenticationService: AuthenticationService,
    private pageloaderService: PageLoaderService,
    private cartService: CartService) {
    this.user = new UserProfileModel();
    this.dropDownPlaceholder = 'Select';
  }

  createFanDropDownList(fanNumbers, dropDownList) {
    for (const fan of fanNumbers) {
      // Allowing only unique id
      if (fan !== dropDownList[0].name) {
        const dropdown: DropdownModel = new DropdownModel();
        dropdown.name = fan;
        dropdown.value = fan;
        dropDownList.push(dropdown);
      }
    }
    return dropDownList;
  }

  getFan(state) {
    const fanList = this.user.fanList;

    const dropDownList = [{ 'name': 'Select', 'value': '' }];
    if (state === 'backinit') {
      this.fanNumbers = this.createFanDropDownList(fanList, dropDownList);
      if (fanList.length === 1) {
        this.editFbtn = false;
      }
    } else {
      if (fanList.length === 1) {
        this.shownFan = fanList[0];
        this.editFbtn = false;
        this.pageloaderService.setPageLoaderStatus(false);
        this.invalidFan = false;
        this.fanMessage = '';
        this.validateProduct();
      } else {
        this.pageloaderService.setPageLoaderStatus(true);
        this.fanNumbers = this.createFanDropDownList(fanList, dropDownList);
        this.selectedFan = this.fanNumbers[0];
        this.showFanDropDown = true;
      }
    }
  }

  selectGoFan() {
    if (this.selectedFan.name !== 'Select' && this.selectedFan.name !== '' && this.selectedFan.name !== undefined) {
      this.shownFan = this.selectedFan.name;
      this.dropbanDownPlaceholder = 'Select';
      this.pageloaderService.setPageLoaderStatus(false);
      this.invalidFan = false;
      this.fanMessage = '';
      this.validateProduct();
    }
  }

  validateProduct() {
    this.cartList = new Array();
    let count = 0;
    this.cart.lineItems.forEach(lineItem => {
      const product = new RequestEligibilityDetailsModel();
      product.productId = lineItem.productId;
      product.itemCode = lineItem.skuId;
      product.quantity = lineItem.quantity;
      this.cartList.push(product);
    });

    this.billingPaymentService.validateSelectedFan(this.utilityService.getEnvConfig().validateFanUrl, this.cartList, this.shownFan)
      .subscribe(obj => {
        this.pageloaderService.setPageLoaderStatus(true);
        obj.lineItems.forEach(lineItem => {
          this.cart.lineItems.forEach(eligibleLineItem => {
            if (lineItem.productId === eligibleLineItem.productId) {
              if (!lineItem.isEligible) {
                count++;
              } else {
                this.eligibleList.push(eligibleLineItem);
              }
            }
          });
        });
        if (count === 0) {
          this.showFanDropDown = false;
          this.banSectionEnable = true;
          this.showBanDropDown = true;
          this.getBanDetails('init');
        } else if (count === obj.lineItems.length) {
          this.pageloaderService.setPageLoaderStatus(true);
          this.setError = false;
          this.invalidFan = true;
          // tslint:disable-next-line:max-line-length
          this.fanMessage = (count > 1) ? 'Thank you for your interest. Your shopping cart contains products you\'re not eligible for. We\'ll need to remove products from your cart. Select a different foundation account or call your administrator' : 'Thank you for your interest. Your shopping cart contains a product you\'re not eligible for. We\'ll need to remove a product from your cart. Select a different foundation account or call your administrator';
        } else {
          this.showRemoveProductModal(count);
        }
      }, err => {
        this.setErrorMessage(err);
      });
  }

  editFan() {
    this.showFanDropDown = true;
    this.banSectionEnable = false;
    this.showBanDropDown = false;
    this.showCtnDropDown = false;
    this.ctnSectionEnable = false;
    this.billingpaymentform.get('ban').setValue('');
    this.billingpaymentform.get('ctn').setValue('');
    this.selectedBan = undefined;
    this.selectedCtn = '';
    this.continueToProdConfig = true;
  }
  getBanDetails(state) {
    this.editBbtn = true;
    const dropDownList = [{ 'name': 'Select', 'value': '' }];
    this.pageloaderService.setPageLoaderStatus(false);
    this.billingPaymentService.getBanDetailsGnFan(this.utilityService.getEnvConfig().getBanUrl, this.shownFan)
      .subscribe(banrespobj => {
        this.setError = false;
        this.pageloaderService.setPageLoaderStatus(true);
        this.ErrorMessage = '';
        if (state === 'backinit') {
          this.showBanDropDown = false;
          if (banrespobj.bansList.length === 1) {
            this.editBbtn = false;
            const optedBan = banrespobj.bansList[0].name ? banrespobj.bansList[0].name : banrespobj.bansList[0];
            this.selectedBan = { 'name': optedBan, 'value': optedBan };
            this.shownBan = optedBan;
            this.showCtnDropDown = true;
            this.showBanDropDown = false;
            this.billingpaymentform.get('ban').setValue(banrespobj.bansList[0]);
            this.banNumbers = banrespobj.bansList;
            this.getCtnDetails();
          } else if (banrespobj.bansList.length <= 15) {
            let dropDownList = [{ 'name': 'Select', 'value': '' }];
            this.banNumbers = this.createFanDropDownList(banrespobj.bansList, dropDownList);
            this.banMatch = false;
            this.banField = false;
          } else {
            this.banNumbers = banrespobj.bansList;
            this.banMatch = false;
            this.banField = true;
          }
        } else {
          if (banrespobj.bansList.length === 1) {
            this.ctnSectionEnable = true;
            this.showCtnDropDown = true;
            this.showBanDropDown = false;
            const optedBan = banrespobj.bansList[0].name ? banrespobj.bansList[0].name : banrespobj.bansList[0];
            this.selectedBan = { 'name': optedBan, 'value': optedBan };
            this.shownBan = optedBan;
            this.billingpaymentform.get('ban').setValue(banrespobj.bansList[0]);
            this.editBbtn = false;
            this.getCtnDetails();
          } else if (banrespobj.bansList.length <= 15) {
            this.banNumbers = this.createFanDropDownList(banrespobj.bansList, dropDownList);
            this.selectedBan = this.banNumbers[0];
            this.banMatch = false;
            this.banField = false;
            // document.getElementById('bandropdown').focus();
          } else {
            this.banNumbers = banrespobj.bansList;
            this.banMatch = false;
            this.banField = true;
          }
        }
      }, err => {
        this.setErrorMessage(err);
      });
  }

  checkBanEntered(event) {
    if (!event || (event && event.keyCode !== KEY_CONFIG.tabKey)) {
      let tmp_ban;
      if (this.banField) {
        tmp_ban = this.billingpaymentform.value.ban;
        tmp_ban = { 'name': tmp_ban, 'value': tmp_ban };
      } else {
        tmp_ban = this.selectedBan;
      }
      if ((this.selectedBan && this.selectedBan.name !== 'Select' && this.selectedBan.name !== '' && this.selectedBan.name !== undefined)
        || (tmp_ban && this.banField)) {
        this.banMatch = false;
        if (this.banNumbers !== undefined) {
          for (const item of this.banNumbers) {
            if ((item.name ? item.name : item) === tmp_ban.name) {
              this.banMatch = true;
              setTimeout(function () {
                document.getElementById('ctninput').focus();
              }, 500);
            }
          }
        }
        if (this.banMatch === false) {
          this.setError = true;
          this.ErrorMessage = 'Enter a valid billing account for the foundation account.';
          this.showCtnDropDown = false;
          this.errorBanFlag = true;
          this.utilityService.loadFocusOnTop();
        } else if (this.banMatch === true) {
          this.setError = false;
          this.ErrorMessage = '';
          this.showCtnDropDown = true;
          this.ctnSectionEnable = true;
          this.showBanDropDown = false;
          const optedBan = tmp_ban.name ? tmp_ban.name : tmp_ban;
          this.selectedBan = { 'name': optedBan, 'value': optedBan };
          this.shownBan = optedBan;
          this.dropbanDownPlaceholder = optedBan;
          this.getCtnDetails();
        }
      }
    }
  }

  editBan() {
    this.showBanDropDown = true;
    this.showCtnDropDown = false;
    this.ctnSectionEnable = false;
    this.billingpaymentform.get('ctn').setValue('');
    this.selectedCtn = '';
    this.continueToProdConfig = true;
  }


  editCtn() {
    this.showCtnDropDown = true;
    this.continueToProdConfig = true;
  }


  matchCtn(event) {
    if (!event || (event && event.keyCode !== KEY_CONFIG.tabKey)) {
      const tmp_ctn = this.billingpaymentform.value.ctn.split('.').join('');
      this.ctnMatch = false;
      if (this.ctnNumbers !== undefined) {
        for (const ctn of this.ctnNumbers) {
          if (ctn === tmp_ctn) {
            this.ctnMatch = true;
          }
        }
      }
      if (this.ctnMatch === false) {
        this.setError = true;
        this.ErrorMessage = 'Enter a valid wireless number for the billing account.';
        this.continueToProdConfig = true;
        this.utilityService.loadFocusOnTop();
      } else if (this.ctnMatch === true) {
        this.continueToProdConfig = false;
        this.showCtnDropDown = false;
        this.setError = false;
        this.ErrorMessage = '';
        this.selectedCtn = this.utilityService.formatTelephoneNumber(tmp_ctn);
      }
    }
  }

  getCtnDetails() {
    this.pageloaderService.setPageLoaderStatus(false);
    this.pageloaderService.setPageLoaderStatus(false);
    this.billingPaymentService.getCtnDetailsGnBan(this.utilityService.getEnvConfig().getCtnUrl, this.selectedBan)
      .subscribe(ctnrespobj => {
        this.pageloaderService.setPageLoaderStatus(true);
        this.setError = false;
        this.ErrorMessage = '';
        if (ctnrespobj.ctnList.length === 1) {
          this.showCtnDropDown = false;
          this.editCbtn = false;
          this.ctnNumbers = ctnrespobj.ctnList;
          this.ctnMatch = false;
          this.billingpaymentform.get('ctn').setValue(ctnrespobj.ctnList[0]);
          this.selectedCtn = this.utilityService.onBlurFormat(ctnrespobj.ctnList[0], 'dot');
          this.continueToProdConfig = false;
        } else {
          this.ctnNumbers = ctnrespobj.ctnList;
          this.editCbtn = true;
          this.ctnMatch = false;
        }
      }, err => {
        this.setErrorMessage(err);
      });
  }

  ctnChange(event) {
    event = Object(event);
    if (event) {
      if (event.keyCode === 46) {
        // not to except .
        event.preventDefault();
      }
      if ((event.charCode >= KEY_CONFIG.numericKey0 && event.charCode <= KEY_CONFIG.numericKey9) ||
        event.keyCode === KEY_CONFIG.backSpaceKey || event.type === 'input') { // ag4104 need to update keycode in
        this.continueToProdConfig = true;
      }
    } else {
      this.continueToProdConfig = true;
    }
  }

  ctnBlur(event) {
    if (event.target.value.match('^[0-9]{1,100}$')) {
      const val = this.utilityService.onBlurFormat(event.target.value, 'dot');
      this.billingpaymentform.get('ctn').setValue(val);
    }
  }

  ctnFocus(event) {
    const val = this.utilityService.onFocusFormat(event.target.value, 'dot');
    this.billingpaymentform.get('ctn').setValue(val);
  }

  ngOnInit() {


    if (sessionStorage.getItem('cart') === null) {
      console.log(this.cart);
      this.router.navigate(['/home']);
      return;
    }

    // document.title = 'AT&T Business Console - Checkout - Billing and Payment';
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    this.authenticationService.setLoginSuccessUrl(this.router.routerState.snapshot.url);
    this.pageloaderService.setPageLoaderStatus(false);
    this.user = this.authenticationService.getUser();
    this.stepindicatorService.setCurrentStep(this.activatedRoute.snapshot.url[0].path);
    this.stepindicatorService.setVisibility(true);
    this.continueToProdConfig = true;
    this.banSectionEnable = false;
    this.showBanDropDown = false;
    this.editFbtn = true;
    this.editBbtn = true;
    this.editCbtn = true;
    this.buildForm();
    if (this.user) {
      this.cart = JSON.parse(sessionStorage.getItem('cart'));
      if (this.cart.fan !== undefined && this.cart.ban !== undefined && this.cart.ctn !== undefined) {
        this.getFan('backinit');
        this.showFanDropDown = false;
        this.shownFan = this.cart.fan;
        this.dropDownPlaceholder = this.cart.fan;
        this.dropbanDownPlaceholder = this.cart.ban;
        this.billingpaymentform.get('ban').setValue(this.cart.ban);
        this.selectedFan = { 'name': this.cart.fan, 'value': this.cart.fan };
        this.selectedBan = { 'name': this.cart.ban, 'value': this.cart.ban };
        this.shownBan = this.cart.ban;
        this.selectedCtn = this.utilityService.formatTelephoneNumber(this.cart.ctn);
        this.billingpaymentform.get('ctn').setValue(this.utilityService.formatTelephoneNumber(this.cart.ctn));
        this.billingPaymentService.getBanDetailsGnFan(this.utilityService.getEnvConfig().getBanUrl, this.shownFan)
          .subscribe(banrespobj => {
            this.banSectionEnable = true;
            this.ctnSectionEnable = true;
            this.showCtnDropDown = false;
            this.showBanDropDown = false;
            const dropDownList = [{ 'name': 'Select', 'value': '' }];
            this.setError = false;
            this.ErrorMessage = '';
            this.banNumbers = this.createFanDropDownList(banrespobj.bansList, dropDownList);
            if (banrespobj.bansList.length === 1) {
              this.editBbtn = false;
            }
            this.pageloaderService.setPageLoaderStatus(true);
            this.getCtnDetails();
          }, err => {
            this.pageloaderService.setPageLoaderStatus(true);
            this.adobeAnalyticsService.CreateSeriveAlertProperties(err.status, err.statusText, 'formResponse');
            this.handleError(err);
          });
        this.continueToProdConfig = false;
      } else {
        this.getFan('init');
      }
    }
    this.billingPaymentService.createPageLoadProperties(this.cart,
      this.router.routerState.snapshot.url,
      'Checkout Step1 Billing payment');
  }

  buildForm(): void { // creating formcontrol as a group that is used as formControlName in html

    this.billingpaymentform = this.formBuilder.group({
      ban: ['', [
        Validators.pattern('^[0-9]{1,100}$')]],
      ctn: ['', [
        Validators.pattern('^[0-9\.]{1,100}$')]]
    });

    this.validationService.validate(
      this.billingpaymentform,
      this.formErrors,
      this.validationMessages);

  }

  setCartObj() {
    this.cart.fan = this.shownFan;
    this.cart.ban = this.shownBan;
    this.cart.ctn = this.selectedCtn.split('.').join('');
    sessionStorage.setItem('cart', JSON.stringify(this.cart));
    // this.billingPaymentService.createBillingFormSubmitLoadProperties(this.cart, 'SUCCESS', 'formSubmit');
    if (this.authenticationService.getUser() === null) {
      // this.router.navigate(['login']);
      window.location.href = '/businessconsole/login';
    } else {
      this.router.navigate(['/checkout/serviceConfiguration']);
    }
  }


  selected(selectedValue: DropdownModel) {
    this.selectedFan = selectedValue;
    if (this.selectedFan.value.length !== 0) {
      this.selectedValueFlag = true;
    } else {
      this.selectedValueFlag = false;
    }
  }

  selectedBanNumber(selectedValue: DropdownModel) {
    this.selectedBan = selectedValue;
    this.dropbanDownPlaceholder = selectedValue.name;
    if (this.selectedBan.value.length !== 0) {
      this.selectedValueFlag = true;
    } else {
      this.selectedValueFlag = false;
    }
  }

  showRemoveProductModal(qty) {
    this.removeProductModalPopup = new ConfirmModalPopupModel();
    // tslint:disable-next-line:max-line-length
    this.removeProductModalPopup.modalMessage = (qty > 1) ? '<p>Thank you for your interest.</p><p>We\'ll need to remove products from your cart which your account isn\'t eligible for. Please call your administrator if you have questions.</p>' : '<p>Thank you for your interest.</p><p>We\'ll need to remove a product from your cart which your account isn\'t eligible for. Please call your administrator if you have questions.</p>';
    this.removeProductModalPopup.modalHeader = 'Ineligible products';
    this.removeProductModalPopup.cancelButtonMessage = 'Cancel';
    this.removeProductModalPopup.confirmButtonMessage = 'OK';
    this.removeProductModalPopup.cancelButtonAccessibilityText = 'Cancel';
    this.removeProductModalPopup.confirmButtonAccessibilityText = 'OK';
    this.modalClass = 'modal-lg';
    this.removeProd = true;
    document.body.classList.add('modal-open');
    this.pageloaderService.setPageLoaderStatus(true);
  }

  removeProduct(event) {
    if (event) {
      const qty = this.cart.lineItems.length - this.eligibleList.length;
      this.cart.lineItems = this.eligibleList;
      sessionStorage.setItem('cart', JSON.stringify(this.cart));
      this.setError = false;
      this.invalidFan = true;
      // tslint:disable-next-line:max-line-length
      this.fanMessage = (qty > 1) ? 'We\'ll need to remove products from your cart because your account isn\'t eligible for them. If you have any questions, call your administrator.' : 'We\'ll need to remove a product from your cart because your account isn\'t eligible for it. If you have any questions, call your administrator.';
      this.showFanDropDown = false;
      this.banSectionEnable = true;
      this.showBanDropDown = true;
      this.getBanDetails('init');
    }
    this.removeProd = false;
    document.body.classList.remove('modal-open');

  }

  cancel() {
    this.cancelCheckout = true;
  }

  goBackToCart() {
    if (this.cart.fan !== undefined && this.cart.fan !== null) {
      delete this.cart.fan;
      sessionStorage.setItem('cart', JSON.stringify(this.cart));
    }

    if (this.cart.ban !== undefined && this.cart.ban !== null) {
      delete this.cart.ban;
      sessionStorage.setItem('cart', JSON.stringify(this.cart));
    }

    if (this.cart.ctn !== undefined && this.cart.ctn !== null) {
      delete this.cart.ctn;
      sessionStorage.setItem('cart', JSON.stringify(this.cart));
    }
    this.stepindicatorService.removeStep('checkout');
    this.router.navigate(['/cart']);
  }

  setErrorMessage(err) {
    this.invalidFan = false;
    this.adobeAnalyticsService.CreateSeriveAlertProperties(err.status, err.statusText, 'formResponse');
    this.pageloaderService.setPageLoaderStatus(true);
    if (err.status === 500) {
      this.setError = true;
      this.ErrorMessage = 'We couldn\'t complete your request. Please try again later.';
      this.errorFlag = true;
    } else if (err.status === 401) {
      this.setError = true;
      this.ErrorMessage = 'Session expired, Please login again.';
      logoutCurrentUser(true);
    } else {
      this.setError = true;
      this.ErrorMessage = 'We couldn\'t complete your request. Please try again later.';
      this.errorFlag = true;
    }
    this.utilityService.loadFocusOnTop();
  }

  handleError(error) {
    throw error;
  }

  ngOnDestroy() {
    this.pageloaderService.setPageLoaderStatus(true);
  }
}
